module.exports = __webpack_public_path__ + "static/media/your-app-icon.9b526c00.svg";